import { createSelector } from 'reselect'

const getFormData =
  (formName) =>
  ({ form }) =>
    form[formName]

const formSelectors = {
  getActiveField: (formName) =>
    createSelector([getFormData(formName)], (formData) => {
      return formData?.active
    }),
  getAnyTouched: (formName) =>
    createSelector([getFormData(formName)], (formData) => {
      return formData?.anyTouched
    }),
  getAttributes: createSelector([getFormData('expenseDetails')], ({ values }) => {
    return values.attributes
  }),
  getLineItemsValues: createSelector([getFormData('expenseDetails')], ({ values }) => {
    return values.lineItems
  }),
  getExportValues: createSelector([getFormData('createReport')], (formData) => {
    return {
      name: formData?.values?.name,
      description: formData?.values?.description,
      startDate: formData?.values?.startDate,
      endDate: formData?.values?.endDate,
    }
  }),
}
// Test
export default formSelectors
